import Component from '@bythepixel/component-loader';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 3,
  rewind: false,
  bound: true,
  gap: 21,
  peek: 4,
  breakpoints: {
    480: {
      focusAt: 'center',
      perView: 1.2,
    },
    768: {
      perView: 2.3,
    },
    1024: {
      perView: 1.5,
    },
  },
};

const selectors = {
  slideSelector: '[data-blog-promo-slide]',
  leftArrowSelector: '[data-blog-promo-arrow-left]',
  rightArrowSelector: '[data-blog-promo-arrow-right]',
  arrowsContainerSelector: '[data-blog-promo-arrows]',
  slideIndicatorSelector: '[data-blog-promo-indicator]',
  slideIndicatorActiveClass: 'nav-btn--active',
  overlaySelector: '--blog-slider-overlay',
};

export default class SectionBlogPromo extends Component {
  static selector = '[data-comp-blog-promo]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.subNavSlider = new GlideSlider(containerEl, glideOptions, selectors);
    this.subNavSliderGlideInstance = this.subNavSlider.getGlideSlider();

    this.subNavSliderGlideInstance.on(['mount.after', 'run.after'], () => {
      this.subNavSlider.handleArrowButtonVisibility();
    });

    this.subNavSliderGlideInstance.mount();
  }
}
